/*---------------------------------------------------------*\
 * Imports
\*---------------------------------------------------------*/
import PubSub from 'pubsub-js';
import keyboard from 'keycode-ui';

const TOPICS = new WeakMap();
const deps = {};
/*---------------------------------------------------------*\
 * NavbarSubMenuController
\*---------------------------------------------------------*/
class NavbarSubMenuController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($scope, $timeout, topics) {
    TOPICS.set(this, topics);
    this.name = 'navbarSubMenu';
    deps.$timeout = $timeout;

    const token = PubSub.subscribe(TOPICS.get(this).headerMain.resetSubnav, () => {
      this.resetSubNav();
    });

    $scope.$watch('vm.items', () => {
      this.resetSubNav();
    });

    $scope.$on('$destroy', () => {
      PubSub.unsubscribe(token);
    });
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  resetSubNav() {
    this.position = this.defaultPosition || 0;
    this.currentSelectedPosition = this.defaultPosition || 0;
    this.rotationMenu = [];
    this.generateRotationMenu();
  }

  generateRotationMenu() {
    if (!this.items) {
      this.items = [];
      this.rotationMenu = [];
      return;
    }

    const count = this.items.length;
    const pos = this.position;
    const previousPos = (count + (pos - 1)) % count;
    const nextPos = (pos + 1) % count;

    this.rotationMenu = [
      this.items[previousPos],
      this.items[pos],
      this.items[nextPos]
    ];
    if (count === 1) {
      this.rotationMenu = [
        null,
        this.items[pos],
        null
      ];
    } else if (count === 2) {
      this.rotationMenu = [
        pos === 0 ? null : this.items[previousPos],
        this.items[pos],
        pos === 0 ? this.items[nextPos] : null
      ];
    } else {
      this.rotationMenu = [
        this.items[previousPos],
        this.items[pos],
        this.items[nextPos]
      ];
    }
  }

  focus(event) {
    this.onFocus({ event });
  }

  blur(event) {
    this.onBlur({ event });

    deps.$timeout(() => {
      if (!this.itemSelected) {
        // if a submenu item wasnt selected we need to reset the position to the last selected position
        this.position = this.currentSelectedPosition || 0;
        this.generateRotationMenu();
      }
      // reset item selected flag
      this.itemSelected = false;
    }, 500);
  }

  navigateLeft(event) {
    const count = this.items.length;
    if (count > 2 || (count === 2 && this.position === 1)) {
      this.position = (count + (this.position - 1)) % count;
    }
    event.preventDefault();
  }

  navigateRight(event) {
    const count = this.items.length;
    if (count > 2 || (count === 2 && this.position === 0)) {
      this.position = (this.position + 1) % count;
    }
    event.preventDefault();
  }

  getCurrentItem() {
    return this.items[this.position];
  }

  selectCurrent() {
    // if a navbar item was selected we record its current selected index so we reset to this position
    // when a user scrolls through the sub menu and exits but does not select an item
    this.itemSelected = true;
    this.currentSelectedPosition = this.position;
    this.onSelect({
      item: this.getCurrentItem()
    });
  }

  //-----------------------------------
  // Events
  //-----------------------------------
  onKeyDown(e) {
    const topics = TOPICS.get(this).nav;
    switch (true) {
      case keyboard.isLeft(e): // ARROW_LEFT
        this.navigateLeft(event);
        this.generateRotationMenu();
        break;
      case keyboard.isRight(e): // ARROW_RIGHT
        this.navigateRight(event);
        this.generateRotationMenu();
        break;
      case keyboard.isEnter(e): // ENTER/OK
        this.selectCurrent();
        PubSub.publish(topics.enter, { source: this.name, data: this.getCurrentItem() });
        break;
      case keyboard.isUp(e): // ARROW_UP:
        PubSub.publish(topics.up, this.name);
        break;
      case keyboard.isDown(e): // ARROW_DOWN:
        PubSub.publish(topics.down, this.name);
        break;
    }
  }
}

NavbarSubMenuController.$inject = ['$scope', '$timeout', 'topics'];

export default NavbarSubMenuController;



/** WEBPACK FOOTER **
 ** ./client/app/components/common/navbarSubMenu/navbarSubMenu.controller.js
 **/